import { Injectable } from '@angular/core';
import { APP_CONFIG } from 'src/assets/config/app-config';

@Injectable({ providedIn: 'root' })
export class DynamicRouteService {
  private readonly pagesMapping = {
    'over-ons': 'about-us',
    diensten: 'services',
    onderwijs: 'education',
    kennisdatabank: 'knowledge-base',
    'voor-bedrijven': 'for-employers',
  };

  /**
   * Get localized route path for navigation
   */
  getLocalizedRoutePath(routeKey: string, params: string[] = []): string {
    let routeSegment = routeKey;
    let translatedParams = params;

    // Only translate if APP_CONFIG.translatePages is true
    if (APP_CONFIG.translatePages) {
      // Translate parameters using the mapping
      translatedParams = params.map((param) => {
        return (
          this.pagesMapping[param as keyof typeof this.pagesMapping] || param
        );
      });
    }

    return `/${routeSegment}${
      translatedParams.length ? '/' + translatedParams.join('/') : ''
    }`;
  }

  /**
   * Convert Dutch page ID to English equivalent
   * @param id - The page ID to convert (e.g., "diensten" -> "services")
   * @returns English page ID or original if no mapping exists
   */
  translatePageId(id: string): string {
    return this.pagesMapping[id as keyof typeof this.pagesMapping] || id;
  }

  /**
   * Convert English page ID to Dutch equivalent
   */
  getDutchPageId(englishId: string): string {
    const reverseMapping = Object.fromEntries(
      Object.entries(this.pagesMapping).map(([dutch, english]) => [
        english,
        dutch,
      ])
    );
    return reverseMapping[englishId] || englishId;
  }
}
